import { $el } from 'src/scripts/utils/utils'
import { BaseComponent } from '../../components/base-component'
import { parseHTML, replaceNodeChildren } from '../../utils/dom'

export class ProductRecommendations extends BaseComponent {
  mountComponent(): void {
    this.update()
  }

  update = (): void => {
    const url = this.dataset.url

    if (!url) {
      return
    }

    fetch(url)
      .then(response => response.text())
      .then(text => {
        this.updateByHTML(parseHTML(text))
      })
      .catch(() => {
        console.log('Error in product recommendations component')
      })
  }

  updateByHTML(html: Document): void {
    const recommendations = $el(
      `product-recommendations[id="${this.id}"]`,
      html,
    )
    replaceNodeChildren(this, recommendations)
  }
}
